<section class="py-6 border-b border-b-shs-gray-4" [formGroup]="orderEntryInternationalForm!">
    <h2 class="text-base font-bold text-font-primary">Additional Information</h2>
    <div class="mt-4 flex flex-col gap-4">
        @switch (orderEntryInternationalForm?.get('issueType')?.value) { @case (orderEntryIssueTypes.WRONG_ACCOUNT_INT)
        {
        <sag-ui-select
            [required]="true"
            label="Select the Account Error Type"
            placeholder=""
            formControlName="accountErrorType"
            class="max-w-input"
        >
            @for (accountErrorType of accountErrorTypes | keyvalue; track $index) {
            <sag-ui-option [value]="accountErrorType.value">{{ accountErrorType.value }}</sag-ui-option>
            }
        </sag-ui-select>
        } @default {
        <sag-ui-textarea
            [required]="true"
            label="Explain the Error that Occurred"
            placeholder="Explain"
            formControlName="errorDescription"
            class="max-w-input"
        ></sag-ui-textarea>
        <sag-ui-radio-group
            label="Can you identify the carton ID# for the box/pallet the product was received in?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio name="canIdentifyCartonId" formControlName="canIdentifyCartonId" [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio name="canIdentifyCartonId" formControlName="canIdentifyCartonId" [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>
        @if (orderEntryInternationalForm?.get('canIdentifyCartonId')?.value) {
        <sag-ui-input
            [required]="true"
            label="Carton / Pallet ID#"
            placeholder="3280823429"
            formControlName="cartonId"
            class="max-w-input"
        ></sag-ui-input>
        } } } @if (showFinancialAdjustment) {
        <sag-ui-select
            [required]="true"
            label="Financial Adjustment Request?"
            placeholder=""
            formControlName="financialAdjustment"
            class="max-w-input"
        >
            @for (financialAdjustment of financialAdjustments() | keyvalue; track $index) {
            <sag-ui-option [value]="financialAdjustment.value">{{ financialAdjustment.value }}</sag-ui-option>
            }
        </sag-ui-select>
        <app-attachments-input [form]="orderEntryInternationalForm!" controlName="relatedDocuments" />
        }
        <div class="flex justify-end max-w-input">
            <sag-ui-button [disabled]="!isValid()" (click)="handleConfirm()" size="sm">Confirm</sag-ui-button>
        </div>
    </div>
</section>
